import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProductPriceComponent } from '@features/product/product-price/product-price.component';
import { SharedModule } from '@shared/shared.module';

import { ProductCardComponent } from './product-card/product-card.component';
import { ProductSplashComponent } from './product-splash/product-splash.component';
import { ActiveSplashPipe } from './pipes/active-splash.pipe';
import { ProductActionsComponent } from './product-actions/product-actions.component';
import { ProductReservablePipe } from './pipes/product-reservable.pipe';
import { ProductAvailablePipe } from './pipes/product-available.pipe';
import { ProductPriceAnydayComponent } from './product-price-anyday/product-price-anyday.component';
import { ProductGiftOptionsComponent } from './product-gift-options/product-gift-options.component';
import { ProductCampaignComponent } from './product-campaign/product-campaign.component';
import { CampaignOnUsePipe } from './pipes/campaign-on-use.pipe';
import { IsMemberTypePipe } from './pipes/member-type.pipe';
import { CampaignByMemberTypePipe } from './pipes/campaign-by-member-type.pipe';
import { SameDayDeliveryPipe } from '@features/product/pipes/same-day-delivery.pipe';
import { FirstSplashPipe } from './pipes/first-splash.pipe';
import { GetCampaignTypePipe } from './pipes/get-campaign-type.pipe';
import { SortSelectedProductPipe } from './pipes/sort-selected-product.pipe';
import { ProductSplashesComponent } from './product-splashes/product-splashes.component';
import { GetPrioritySplashPipe } from './pipes/get-priority-splash.pipe';
import { GetCampaignSplashPipe } from './pipes/get-campaign-splash.pipe';
import { ProductUspCardComponent } from './product-usp-card/product-usp-card.component';
import { IsPreOrderPipe } from './pipes/is-pre-order.pipe';
import { GetVariantFromRelatedPropertyPipe } from './pipes/get-variant-from-related-property.pipe';
import { GetSelectedVariantPipe } from './pipes/get-selected-variant.pipe';
import { GetMatchColorPipe } from './pipes/get-match-color.pipe';
import { HasRelatedPropertiesPipe } from './pipes/has-related-properties.pipe';
import { GetSplashesPipe } from './pipes/get-splashes.pipe';

@NgModule({
    imports: [CommonModule, SharedModule, RouterModule, ProductCardComponent,
        ProductPriceComponent,
        ProductSplashComponent,
        ActiveSplashPipe,
        ProductActionsComponent,
        ProductReservablePipe,
        ProductAvailablePipe,
        ProductPriceAnydayComponent,
        ProductGiftOptionsComponent,
        ProductCampaignComponent,
        CampaignOnUsePipe,
        IsMemberTypePipe,
        CampaignByMemberTypePipe,
        SameDayDeliveryPipe,
        FirstSplashPipe,
        GetCampaignTypePipe,
        SortSelectedProductPipe,
        ProductSplashesComponent,
        GetPrioritySplashPipe,
        GetCampaignSplashPipe,
        ProductUspCardComponent,
        IsPreOrderPipe,
        GetVariantFromRelatedPropertyPipe,
        GetSelectedVariantPipe,
        GetMatchColorPipe,
        HasRelatedPropertiesPipe,
        GetSplashesPipe],
    exports: [
        ProductCardComponent,
        ProductPriceComponent,
        ProductSplashComponent,
        ProductActionsComponent,
        ProductGiftOptionsComponent,
        CampaignByMemberTypePipe,
        GetCampaignTypePipe,
        FirstSplashPipe,
        CampaignOnUsePipe,
        SortSelectedProductPipe,
        GetPrioritySplashPipe,
        GetCampaignSplashPipe,
        IsPreOrderPipe,
        ActiveSplashPipe,
        ProductUspCardComponent,
        GetVariantFromRelatedPropertyPipe,
        GetSelectedVariantPipe,
        GetMatchColorPipe,
        HasRelatedPropertiesPipe,
        GetSplashesPipe
    ]
})
export class ProductModule {}
